import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getProductiveCycleStageTemplateList,
	addNewProductiveCycleStageTemplate,
	updateProductiveCycleStageTemplate,
	deleteProductiveCycleStageTemplate,
	getProductiveCycleStageTemplate,
	existsProductiveCycleStageTemplate,
} from '../productiveCycleStageTemplate/thunk';

export const initialState = {
	itemProductiveCycleStageTemplateList: [],
	itemProductiveCycleStageTemplateDetail: null,
	isProductiveCycleStageTemplateLoading: false,
	isProductiveCycleStageTemplateSuccess: false,

	productiveCycleStageTemplateList: [],
	productiveCycleStageTemplateListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ProductiveCycleStageTemplateSlice = createSlice({
	name: 'ProductiveCycleStageTemplate',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getProductiveCycleStageTemplate.fulfilled, (state, action) => {
			state.isProductiveCycleStageTemplateLoading = false;
			state.isProductiveCycleStageTemplateSuccess = true;
			state.itemProductiveCycleStageTemplateDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getProductiveCycleStageTemplate.pending, state => {
			state.isProductiveCycleStageTemplateLoading = true;
			state.isProductiveCycleStageTemplateSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getProductiveCycleStageTemplate.rejected, (state, action) => {
			state.isProductiveCycleStageTemplateLoading = false;
			state.isProductiveCycleStageTemplateSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getProductiveCycleStageTemplateList.pending, state => {
			state.isProductiveCycleStageTemplateSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getProductiveCycleStageTemplateList.fulfilled, (state, action) => {
			state.itemProductiveCycleStageTemplateList = action.payload;
			state.productiveCycleStageTemplateList = action.payload;
			state.isLoadingList = false;
			state.isProductiveCycleStageTemplateSuccess = true;

			let productiveCycleStageTemplateListSelect = [];
			action.payload.map(item =>
				productiveCycleStageTemplateListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.productiveCycleStageTemplateListSelect = productiveCycleStageTemplateListSelect;
		});
		builder.addCase(getProductiveCycleStageTemplateList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isProductiveCycleStageTemplateSuccess = true;
		});
		builder.addCase(addNewProductiveCycleStageTemplate.fulfilled, (state, action) => {
			state.itemProductiveCycleStageTemplateList.push(action.payload);
			state.productiveCycleStageTemplateList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewProductiveCycleStageTemplate.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewProductiveCycleStageTemplate.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateProductiveCycleStageTemplate.fulfilled, (state, action) => {
			state.itemProductiveCycleStageTemplateList = state.itemProductiveCycleStageTemplateList.map(productiveCycleStageTemplate =>
				productiveCycleStageTemplate.productiveCycleStageTemplatename === action.payload.old_productiveCycleStageTemplate
					? { ...productiveCycleStageTemplate, ...action.payload.updated_productiveCycleStageTemplate }
					: productiveCycleStageTemplate
			);
			state.productiveCycleStageTemplateList = state.productiveCycleStageTemplateList.map(productiveCycleStageTemplate =>
				productiveCycleStageTemplate._id.toString() === action.payload._id.toString()
					? { ...productiveCycleStageTemplate, ...action.payload }
					: productiveCycleStageTemplate
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateProductiveCycleStageTemplate.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateProductiveCycleStageTemplate.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteProductiveCycleStageTemplate.fulfilled, (state, action) => {
			state.itemProductiveCycleStageTemplateList = current(state.itemProductiveCycleStageTemplateList).filter(
				item => item._id !== action.payload._id
			);
			state.productiveCycleStageTemplateList = current(state.productiveCycleStageTemplateList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteProductiveCycleStageTemplate.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteProductiveCycleStageTemplate.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});

		
		builder.addCase(existsProductiveCycleStageTemplate.fulfilled, (state, action) => {
			state.isProductiveCycleStageTemplateLoading = false;
			state.isProductiveCycleStageTemplateSuccess = true;
			state.itemProductiveCycleStageTemplateDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(existsProductiveCycleStageTemplate.pending, state => {
			state.isProductiveCycleStageTemplateLoading = true;
			state.isProductiveCycleStageTemplateSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(existsProductiveCycleStageTemplate.rejected, (state, action) => {
			state.isProductiveCycleStageTemplateLoading = false;
			state.isProductiveCycleStageTemplateSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});


	},
});

export const { setRequireCloseModal } = ProductiveCycleStageTemplateSlice.actions;

export default ProductiveCycleStageTemplateSlice.reducer;
